type ErrorHandlerProps = {
  error: Error;
  resetErrorBoundary?: (...args: unknown[]) => void;
};

export function ErrorHandler(_props: ErrorHandlerProps) {
  return (
    <div className="flex-center">
      <h3 className="text-red text-sm">Something went wrong.</h3>
      {/* <BaseButton onClick={resetErrorBoundary} text="Retry" /> */}
    </div>
  );
}
